import React, { useState } from "react";
import { Plus } from "lucide-react";

const faqs = [
  { q: "Preciso aparecer nos vídeos?", a: "Não. Dentro da VSA você aprende os dois caminhos: perfil com rosto e perfil dark — sem aparecer, sem mostrar identidade. Os dois vendem." },
  { q: "Preciso ter seguidores pra começar?", a: "Não. O TikTok Shop não depende de seguidor. Depende de vídeo certo. Você pode ter zero seguidores hoje e fazer sua primeira venda ainda essa semana." },
  { q: "Preciso investir em tráfego pago?", a: "Não. O método é 100% orgânico. O próprio algoritmo do TikTok entrega seu vídeo pra quem está pronto pra comprar — sem anúncio, sem custo extra." },
  { q: "Nunca vendi nada online. Consigo aplicar?", a: "Sim. A estrutura foi feita do zero absoluto. Você não precisa de experiência, de produto próprio nem de conhecimento técnico." },
  { q: "Quanto tempo até ver resultado?", a: "Alunos que aplicam a estrutura consistentemente relatam as primeiras vendas em dias. O resultado escala com a execução — não com o tempo." },
  { q: "Como funciona o suporte?", a: "Você tem suporte ativo dentro da comunidade, calls semanais com alunos e acesso a estratégias atualizadas conforme a plataforma evolui. Você não fica sozinho." },
  { q: "O conteúdo é atualizado?", a: "Sim. O TikTok Shop muda rápido — e o que funciona hoje pode mudar amanhã. Por isso as estratégias são atualizadas continuamente, em primeira mão." },
  { q: "Tem garantia?", a: "Sim. 7 dias de garantia incondicional. Se não gostar por qualquer motivo, devolvemos 100% do valor. Sem perguntas." },
];

const FAQSection = () => {
  const [open, setOpen] = useState(0);
  return (
    <section className="section" style={{ background: "#050505" }}>
      <div className="container" style={{ maxWidth: 880 }}>
        <h2 className="h-title" style={{ textAlign: "center", marginBottom: 40 }}>
          Perguntas <span className="yellow">frequentes</span>
        </h2>
        <div>
          {faqs.map((f, i) => (
            <div key={i} className={`faq-item ${open === i ? "open" : ""}`}>
              <div className="faq-question" onClick={() => setOpen(open === i ? -1 : i)}>
                <span>{f.q}</span>
                <span className="plus"><Plus size={16} strokeWidth={2.5} /></span>
              </div>
              <div className="faq-answer">
                <p style={{ color: "rgba(255,255,255,0.75)", fontSize: 15.5, lineHeight: 1.7 }}>{f.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
